import { useCallback, useMemo, useState } from 'react';

/**
 * The "Saving…" state of the top bar (design catalog-add-song h2): true while one save of any step
 * runs. `track` wraps the promise of a save and gives it back.
 */
export function useSavingCount() {
  const [count, setCount] = useState(0);

  const track = useCallback(<T>(promise: Promise<T>): Promise<T> => {
    setCount((value) => value + 1);
    return promise.finally(() => setCount((value) => Math.max(0, value - 1)));
  }, []);

  return useMemo(() => ({ isSaving: count > 0, track }), [count, track]);
}

export type TrackSave = ReturnType<typeof useSavingCount>['track'];
